export const families = [
  {
    title: 'Encontre lojas',
    href: '/explore',
    icon: 'fas fa-search-location',
    description: 'Explore as lojas que já fazem parte do nosso ecossistema',
  },
  {
    title: 'Acompanhe pedidos',
    href: '/orders',
    icon: 'fas fa-box',
    description: 'Veja um resumo do acompanhamento do seu pedido, sem precisar se autenticar',
  },
];

export const institutions = [
  {
    title: 'Escolas de educação básica',
    href: '/solutions/k-12',
    icon: 'fas fa-school',
    description:
      'Tenha sua loja online para vender produtos ou serviços educaiconais para Educação Infantil, Ensino Fundamental ou Ensino Médio',
  },
  {
    title: 'Escolas de idiomas',
    href: '/solutions/language-schools',
    icon: 'fas fa-language',
    description: 'Para quem precisa vender produtos ou serviços para diretamente para os alunos',
  },
  {
    title: 'Faculdades e universidades',
    href: '/solutions/colleges',
    icon: 'fas fa-graduation-cap',
    description:
      'Ofereça alternativas de compra para produtos ou serviços complementares aos cursos de graduação, pós-graduação, entre outros',
  },
  {
    title: 'Grupos educacionais',
    href: '/solutions/educational-groups',
    icon: 'fas fa-building',
    description:
      'Organize as vendas online do seu ecossistema de empresas ou instituições educacionais',
  },
];

export const sellers = [
  {
    title: 'Editoras e sistemas de ensino',
    href: '/solutions/publishers',
    icon: 'fas fa-book',
    description:
      'Venda seus títulos diretamente para os consumidores finais através do marketplace das instituições de ensino',
  },
  {
    title: 'Cursos livres e complementares',
    href: '/solutions/after-school',
    icon: 'fas fa-chalkboard-teacher',
    description:
      'Ofereça a matrícula de cursos livres ou venda soluções complementares diretamente para os alunos ou responsáveis',
  },
  {
    title: 'Confecções, livrarias e papelarias',
    href: '/solutions/retail',
    icon: 'fas fa-tshirt',
    description: 'Venda de uniformes escolares ou materiais de papelaria para a lista escolar',
  },
  {
    title: 'Soluções e plataformas digitais',
    href: '/solutions/digital-platforms',
    icon: 'fas fa-cloud',
    description:
      'Venda diretamente aos consumidores finais soluções e plataformas digitais em um único lugar',
  },
];

export const features = [
  {
    title: 'Comece hoje mesmo seu marketplace',
    description:
      'Inicie gratuitamente o marketplace da sua instituição de ensino, sem burocracia e de forma rápida.',
    illustration: '/images/illustrations/solutions/feature-1.svg',
    href: '/platform/marketplace',
  },
  {
    title: 'Abra seu e-commerce e comece a vender online',
    description: 'Tenha seu e-commerce educacional com baixo custo e sem dor de cabeça, comece.',
    illustration: '/images/illustrations/solutions/feature-2.svg',
    href: '/platform/e-commerce',
  },
  {
    title: 'Venda em centenas de marketplaces educacionais',
    description:
      'Tenha acesso e venda diretamente aos consumidores finais das instituições de ensino, sem grandes investimentos e totalmente customizado ao setor de educação.',
    illustration: '/images/illustrations/solutions/feature-3.svg',
    href: '/platform/seller',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: '/images/partners/marketplaces/magno.jpg',
      variant: 'rounded',
    },
    authorName: 'Karen V.',
    authorOccupation: 'School Shop (Colégio Magno)',
    feedback:
      'No momento que eu precisava de uma solução rápida para a minha loja, a Eskolare me foi apresentada e eles realmente cumpriram com a proposta de forma rápida e eficiente. Desde o início até hoje a equipe, além de prestativa, é toda muito simpática e disponível.',
  },
  {
    authorPhoto: {
      src: '/images/partners/sellers/raiz-educacao.png',
      variant: 'rounded',
    },
    authorName: 'Leonardo C.',
    authorOccupation: 'Raiz Educação',
    feedback:
      'Nós conhecemos a Eskolare no final de 2019 quando buscávamos uma solução de pagamento para os serviços terceirizados das nossas escolas. Fechamos a parceria e implementamos já para o ano letivo de 2020. A plataforma é super intuitiva e amigável. Tanto os fornecedores quanto os pais e alunos adoram!',
  },
  {
    authorPhoto: {
      src: '/images/partners/sellers/dsop.png',
      variant: 'rounded',
    },
    authorName: 'Dorinha M.',
    authorOccupation: 'DSOP',
    feedback:
      'Estou muito feliz de ter a Eskolare como parceira da DSOP para facilitar as vendas às nossas escolas. A Eskolare prepara uma loja virtual especificamente para aquela escola com todo o material, isso facilita a compra para o pai, basta ele selecionar a série do filho e já aparecerá o livro indicado pela escola para o filho dele. Temos ainda a vantagem de colocar a nossa logística de frete grátis para as escolas ou direto para a casa do pai, o que facilita a vida das famílias que tem um rotina bem corrida.',
  },
];
